import { hubManagerData } from "../slices/hub_manager";
import api from "../controllers/api";
export const getAgentsFromRolesAPI = async (roleName, hub_id, limit) => {
  try {
    let url = `/account/all${roleName ? "?role_name=" + roleName + "&" : ""}${hub_id ? "hub_id=" + hub_id + "&" : ""}`;
    if (limit) {
      url += "&limit=" + limit;
    }
    const result = await api.get(url);
    if (result.results.length < 1) {
      throw "can not get results result is empty";
    }
    return result;
  } catch (error) {
    return error;
  }
};

export const carListAPI = async (hubId, limit, page) => {
  try {
    const url = `/fleet/all?status=rtd${hubId ? "&hub_id=" + hubId : ""}${limit ? "&limit=" + limit + "&" : ""}${page ? "&page=" + page + "&" : ""}`;
    const result = await api.get(url);
    // if(result.results?.fleetCount < 1){
    //     throw "Result is empty array"
    // }
    return result;
  } catch (error) {
    return error;
  }
};

export const rentalSchemeOptionsAPI = async (hubmanagerId) => {
  try {
    const url = `/scheme/get?hub_id=${hubmanagerId}`;
    const result = api.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const addAllocations = async (data) => {
  // primary driver account id
  // driver manager account id
  // verification agent account id
  // onboarding agent account id
  // telecaller account id
  // const data ={
  // vechileId
  //     primary_accountId:primary_accountID,
  //     dm_accId: driver_manager_accocuntID,
  //     verificationAgent_accId :verfication_agent_accountID,
  //     onboardingAgent_accId :onboarding_agent_accountID,
  //     teleCaller_accId :telecaller_agent_accountID
  // }

  try {
    const url = `/account/driver_mappings`;
    const result = await api.post(url, [data]);
    return result;
  } catch (error) {
    throw error;
  }
};
